export enum LOADING_ACTION_TYPES {
  SAVING = 'Saving',
  LOADING = 'Loading',
}
